<template>
  <div v-if="powerLoading" v-loading="powerLoading"></div>
  <SaasBusinessOpportunityGuidance v-else-if="showNoPermission" :config="billConfig" />
  <div id="MyBill" v-else>
    <subTitle :title="$t(`我的账单记录`)" :tip="$t(`提示：当月用量统计截止昨天24:00。`)"></subTitle>
    <ul class="tabs">
      <li v-for="(item, index) in tabList" :key="index" :class="activeName == item.val ? 'active' : ''" @click="changeActive(item.val)">
        {{ item.name }}
      </li>
    </ul>
    <div class="bill-section" v-if="activeName === 0">
      <div class="common-body" v-loading="loading">
        <es-table :data="List" header-theme="default">
          <es-table-column :label="$t(`产品名称`)" prop="productName"></es-table-column>
          <es-table-column :label="$t(`已使用量`)">
            <template slot-scope="scope">
              <span v-if="scope.row.units === 'G'">{{ showDataUnit(scope.row.used, 'floor', scope.row) }}</span>
              <span v-else>{{ scope.row.used + forMatUnit(scope.row) }}</span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`剩余可用总量`)">
            <template slot-scope="scope">
              <span v-if="scope.row.unlimited">{{ $t('无限') }}</span>
              <span v-else-if="scope.row.units === 'G'">{{ showDataUnit(scope.row.margin, 'floor', scope.row) }}</span>
              <span v-else>{{ scope.row.margin + forMatUnit(scope.row) }}</span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`预扣用量/预扣待返还`)" v-if="showLockNum">
            <template slot-scope="scope">
              <span v-if="scope.row.lockNum <= 0">-- / --</span>
              <span v-else>
                <span v-if="scope.row.lockNum > 0">
                  {{
                    scope.row.units === 'G'
                      ? showDataUnit(scope.row.lockNum, 'floor', scope.row)
                      : scope.row.lockNum + forMatUnit(scope.row)
                  }}
                </span>
                <span v-if="scope.row.lockNum > 0">/</span>
                <span v-if="scope.row.lockReturnNum > 0">
                  {{
                    scope.row.units === 'G'
                      ? showDataUnit(scope.row.lockReturnNum, 'floor', scope.row)
                      : scope.row.lockReturnNum + forMatUnit(scope.row)
                  }}
                </span>
                <span v-if="scope.row.lockNum > 0 && !scope.row.lockReturnNum">
                  {{ scope.row.units === 'G' ? showDataUnit(0, 'floor', scope.row) : 0 + forMatUnit(scope.row) }}
                </span>
              </span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`已转售量`)" v-if="isValitSys">
            <template slot-scope="scope">
              <span v-if="scope.row.units === 'G'">{{ showDataUnit(scope.row.zsUsed, 'floor', scope.row) }}</span>
              <span v-else>{{ scope.row.zsUsed + forMatUnit(scope.row) }}</span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`剩余可转售总量`)" v-if="isValitSys">
            <template slot-scope="scope">
              <span v-if="scope.row.unlimited">{{ $t('无限') }}</span>
              <span v-else-if="scope.row.units === 'G'">{{ showDataUnit(scope.row.zsMargin, 'ceil', scope.row) }}</span>
              <span v-else>{{ getShowPrice(scope.row, 'zsMargin', 'G') + forMatUnit(scope.row) }}</span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`操作`)">
            <template slot-scope="scope">
              <es-button type="text" @click="jumpDetail(scope.row)">{{ $t('查看账单') }}</es-button>
              <es-button type="text" @click="jumpResellRecord(scope.row)" v-if="isValitSys">{{ $t('转售记录') }}</es-button>
              <es-button type="text" @click="jumpAuthRecord(scope.row)">{{ $t('授权记录') }}</es-button>
            </template>
          </es-table-column>
          <template slot="empty">
            <es-empty
              style="margin: 25px; color: #999; line-height: 40px"
              :description="$t(`暂无更多数据`)"
              image="data:image/png;base64,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"></es-empty>
          </template>
        </es-table>
      </div>
    </div>
    <delivery-mage v-if="activeName === 1"></delivery-mage>
  </div>
</template>
<script>
import { $t } from '@/locales'
import { SaasBusinessOpportunityGuidance } from '@esign-saas-component/esign-design-saas'
import subTitle from '@/components/subTitle'
import { mapState } from 'vuex'
import { getShowPrice, showDataUnit, hasPower } from '@/util.js'
import deliveryMage from './deliveryMage.vue'

export default {
  components: {
    subTitle,
    deliveryMage,
    SaasBusinessOpportunityGuidance,
  },
  computed: {
    ...mapState({
      currentCompany: state => state.currentCompany,
      userInfo: state => state.userInfo,
    }),
  },
  watch: {
    currentCompany() {
      this.getList()
    },
  },
  data() {
    const date = new Date()
    const month = date.getMonth() + 1
    const monthList = []
    for (let i = 0; i < 6; i++) {
      let nowDate = month - i
      if (nowDate <= 0) {
        nowDate += 12
      }
      monthList.push({
        id: nowDate,
        value: this.$Dic.monthList[nowDate],
      })
    }

    return {
      showDataUnit,
      getShowPrice,
      showLockNum: false,
      loadingButton: false,
      search: {
        startTime: '',
        endTime: '',
        month,
        proId: Number(this.$route.query.proId) || '',
      },
      monthList,
      List: [],
      isValitSys: false,
      time: '',
      platform: [],
      orderId: '',
      proList: [],
      tabList: [
        {
          name: $t('账单记录'),
          val: 0,
        },
      ],

      activeName: 0,
      loading: false,
      powerLoading: true,
      showNoPermission: false,
      billConfig: {
        noFunctionIllustrateType: 'NO_PRIVILEGE',
        illustrateControl: {
          adminName: '',
        },
      },
    }
  },
  methods: {
    async getNav() {
      const showDeliveryMage = await this.getDelivery()
      if (showDeliveryMage) {
        this.tabList.push({
          name: $t('发货记录'),
          val: 1,
        })
      }
    },
    // 产品名称
    getProList() {
      this.$ajax(this.$url.getproductList()).then(res => {
        this.proList = res.data || []
      })
    },
    getDelivery() {
      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getAvailableList(), {}).then(res => {
          resolve(res.data.length > 0)
        })
      })
    },
    changeActive(val) {
      this.activeName = val
    },
    forMatUnit({ saleType, units }) {
      return saleType === 1 ? units : $t('元')
    },
    jumpResellRecord(item) {
      this.$router.push({
        path: '/resellRecord',
        query: {
          proId: item.productId,
          isResell: 1,
        },
      })
    },
    // 跳转到授权记录
    jumpAuthRecord(item) {
      this.$router.push({
        path: '/resellRecord',
        query: {
          orderId: '',
          proId: item.productId,
          isResell: 0,
          gid: item.gid,
        },
      })
    },
    getValitSys() {
      this.$ajax(this.$url.valitSys(), {}).then(res => {
        this.isValitSys = res.data
      })
    },
    changeTime() {
      if (this.search.startTime && this.search.endTime) {
        this.search.month = ''
      }
    },
    clickTime() {
      this.search.startTime = ''
      this.search.endTime = ''
    },
    jumpDetail(item) {
      let year
      let month
      if (this.search.startTime && this.search.endTime) {
        year = this.search.endTime.getFullYear()
        month = this.search.endTime.getMonth() + 1
      } else {
        // eslint-disable-next-line prefer-destructuring
        month = this.search.month
        if (this.search.month <= this.monthList[0].id) {
          year = new Date().getFullYear()
        } else {
          year = new Date().getFullYear() - 1
        }
      }
      this.$router.push({
        path: '/BillDetail',
        query: {
          proId: item.productId,
          year,
          month,
        },
      })
    },
    clear() {
      this.search = {
        startTime: '',
        endTime: '',
        month: new Date().getMonth() + 1,
      }
      this.getList()
    },

    getList() {
      this.loading = true
      const data = {
        startYear: 2018,
        startMonth: 10,
        endYear: 2018,
        endMonth: 10,
      }
      if (this.search.startTime && this.search.endTime) {
        data.startMonth = this.search.startTime.getMonth() + 1
        data.startYear = this.search.startTime.getFullYear()
        data.endYear = this.search.endTime.getFullYear()
        data.endMonth = this.search.endTime.getMonth() + 1
      } else {
        // eslint-disable-next-line no-multi-assign
        data.endMonth = data.startMonth = this.search.month
        if (this.search.month <= this.monthList[0].id) {
          // eslint-disable-next-line no-multi-assign
          data.endYear = data.startYear = new Date().getFullYear()
        } else {
          // eslint-disable-next-line no-multi-assign
          data.endYear = data.startYear = new Date().getFullYear() - 1
        }
      }
      this.loadingButton = true
      this.$ajax(this.$url.recordReport(), data)
        .then(res => {
          this.loading = false
          this.loadingButton = false
          this.List = res.data || []
          this.showLockNum = this.List.some(item => item.lockNum > 0)
        })
        .catch(() => {
          this.loading = false
          this.loadingButton = false
        })
    },
  },
  async created() {
    let userPower = {}
    this.powerLoading = true
    try {
      userPower = await this.$ajax(this.$url.privileges(), {
        orgId: this.userInfo?.orgId,
      })
    } catch (e) {
      console.log(e)
    }

    if (userPower?.data?.bizPrivilegeModels) {
      this.showNoPermission = !hasPower(userPower?.data?.bizPrivilegeModels, { fun: 'BILL', subFun: 'QUERY' })
    }

    this.powerLoading = false

    if (this.showNoPermission) return

    this.getList()
    this.getValitSys()
    this.getNav() // 获取发货管理权限
    this.getProList()
  },
  mounted() {
    const date = new Date()
    this.time = `${date.getFullYear()}-${date.getMonth() + 1}`
  },
}
</script>
<style lang="less" scoped>
.tabs {
  display: flex;
  margin: 10px 24px;
  border-bottom: 1px solid #00000017;

  > li {
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #000000a6;
    height: 40px;
    line-height: 40px;
    min-width: 102px;
    width: auto;
  }

  li.active {
    border-bottom: 2px solid #1063f1;
    color: #1063f1;
    font-weight: 600;
  }

  li:hover {
    color: #1063f1;
  }
}

.search-section {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0 24px;
  min-height: 64px;

  .search-item {
    height: 37px;
    margin-bottom: 5px;

    &.order-num {
      display: flex;
      align-items: center;

      span {
        width: 100px;
      }
    }
  }
}

.search-btn {
  display: flex;
  justify-content: end;
  margin: 0 20px 20px 20px;
}

/deep/ .es-empty__image {
  width: 64px;
}
</style>
